<template>
  <div class="rewrite-block">
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              ご入力いただいたメールアドレスは既に登録済みのようです。<br />
              <a href="https://www.daini-agent.jp/account/login">こちらからログイン</a>し、本サービスをご利用ください。
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="chat-item chat-item--anser chat-item--input" :class="displayUserIconClass($parent.formData.sex)" v-if="show.answer || show.next">
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.answer">
          <div class="input--col1">
            <input type="text" v-model="email" placeholder="メールアドレス">
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          v-if="show.next"
          @click="clickFixEmail"
        >次へ</button>
      </transition>
    </div>
    <transition name="fade">
      <div class="chat-item chat-item--anser" :class="displayUserIconClass($parent.formData.sex)" v-if="show.fix">
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ email }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import functionsMixin from '../../mixins/functionsMixin'
import WritingAnimation from '../animations/WritingAnimation'

export default {
  name: 'FormRewriteEmail',
  mixins: [GenderMixin, functionsMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        question: false,
        answer: false,
        next: false,
        fix: false,
        writing_2: false,
        confirmMessage: false
      },
      email: null
    }
  },
  mounted: function () {
    this.autoScroll()
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question = true
      this.autoScroll()
      setTimeout(function () {
        this.show.answer = true
        this.autoScroll()
      }.bind(this), 500)
    }.bind(this), 1000)
  },
  watch: {
    email: function () {
      if (this.email) {
        let mailReg = /^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
        if (mailReg.test(this.email)) {
          this.show.next = true
          this.autoScroll()
        }
      }
    }
  },
  methods: {
    clickFixEmail: function () {
      this.show.answer = false
      this.show.next = false
      this.show.fix = true
      this.$emit('form-fix-rewrite-email', this.email)
    }
  }
}
</script>

<style lang="scss" scoped>
.rewrite-block {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormRewriteEmail.vue